import {writable, derived} from "svelte/store";

export const loaded = writable(JSON.parse(localStorage.getItem('loaded')) || false);
loaded.subscribe(value => localStorage.setItem('loaded', JSON.stringify(value)));

export const display = writable(JSON.parse(localStorage.getItem("display")) || 'd');
display.subscribe(val => localStorage.setItem("display", JSON.stringify(val)));


export const user = writable(JSON.parse(localStorage.getItem('user')) || false);
user.subscribe(value => localStorage.setItem('user', JSON.stringify(value)));

function createEmeters(){
    const {subscribe, set, update } = writable(JSON.parse(localStorage.getItem('emeters')) || []);
    return {
        subscribe,
        setEmeters: (list) => set(list),
        reset: () => set([])
    }
}

export const emeters = createEmeters();
emeters.subscribe(val => localStorage.setItem('emeters' , JSON.stringify(val)));

function createIntegrated(){
    const {subscribe, update, set} = writable(JSON.parse(localStorage.getItem('integrated_list')) || []);
    return {
        subscribe,
        setIntegrated: (list) => set(list),
        updateIntegrated: (val) => update(integrated_list => [...val]),
        reset: () => set([])
    }
}

export const integrated_list = createIntegrated();
integrated_list.subscribe(val => localStorage.setItem('integrated_list', JSON.stringify(val)));

export const devices = derived(emeters, $emeters => {
    let em = [],  em_3 = [];
    for (const dev of $emeters) {
        // console.log('DEV', dev);
        if(dev.type === 'SHEM-3'){
            em_3.push({id: dev.id, name: dev.name, category: dev.category, type: dev.type})
        } else {
            let splitId = dev.id.split("_")[0];
            let findInd = em.findIndex(el => el.id == splitId);
            if(findInd === -1){
                em.push({id: splitId, name: dev.name, category: dev.category, type:dev.type})
                // console.log('EM ',em)
            } else {
                em[findInd].name = `${em[findInd].name} / ${dev.name}`;
            }
        }
    }
    return [...em, ...em_3];
});